<template lang="pug">
  v-slide-y-reverse-transition(mode="out-in")
    v-row(v-if="!$loader.isLoading")
      v-col(cols=12 md=6 lg=8 order=1).relative
        v-overlay.align-start.pt-8(
          v-if="course.contract && !course.contract.isMyEnrollment"
          absolute
          :value="!course.contract.userViewContract"
        )
          v-card(light).sdo-card.mx-4
            v-card-title Ознакомьтесь с договором
            v-card-text
              v-card.sdo-card.overflow-auto(max-height=500 )
                v-card-text(v-html="course.contract.listener_preview_document")
                div.py-2(v-intersect="onIntersect")
            v-card-actions
              v-btn(
                color="primary"
                :disabled='!isIntersect' block
                @click="course.contract.viewContract()"
              ) Ознакомлен с договором
        .sdo-radius.grey.lighten-4.pa-4.py-5.mb-8
          div: strong Курс
          span {{ course.title }}
        v-fade-transition(leave-absolute)
          router-view(
            :course="course"
          )

      v-col(cols=12 md=6 lg=4 :order="isMobile ? '-1' : '2'")
        component(
          v-if="course"
          :course="course"
          :enrollment="course.priority_user_prior_record"
          :is="educationStatusComponent"
        ).mb-6
          template(#slot="{ color }")
            .d-flex(v-if="course.contract && course.contract.id")
              v-btn.ml-auto(
                outlined :color="color"
                @click="routeContract(course)"
              ) к Договору
                v-icon(right) mdi-arrow-right

        course-translation

        user-record(
          v-if="userRecord && userRecord.group"
          :group="userRecord.group"
          :course="course"
        )

        v-expand-transition
          v-alert(
            v-if="!course.attributes_filled"
            type="error"
            color="warning"
            text
            outlined
          ).sdo-radius.mb-6
            p(
              v-if="!course.user_group_id"
            ) Внимание! Для принятия решения о зачислении внесите всю необходимую информацию
            div(
              :class="{ 'pb-2': !isMobile }"
            ) Пожалуйста, предоставьте необходимую  информацию для решения
              |  бюрократических вопросов
            v-row.ma-0
              v-spacer
              v-btn(
                depressed
                color="warning" small
                :to=`{
                  name: 'UserRecordCourse',
                  params: { courseId: course.id },
                }`
              ) Заполнить

        contract-alert(
          v-if="course.contract && contractAlertView"
          :contract="course.contract"
          :course="course"
        )

</template>

<script>
import UnitCard from '../../components/UnitCard.vue';
import StudentEnrollWait from '../../components/StatusAlerts/StudentEnrollWait.vue';
// import StudentEnrollRefused from '../components/StatusAlerts/StudentEnrollRefused.vue';
import StudentEnrolled from '../../components/StatusAlerts/StudentEnrolled.vue';
import StudentAllowedAttestation from '../../components/StatusAlerts/StudentAllowedAttestation.vue';
import StudentAttestated from '../../components/StatusAlerts/StudentAttestated.vue';
import StudentRefusedAttestation from '../../components/StatusAlerts/StudentRefusedAttestation.vue';
import StudentExcluded from '../../components/StatusAlerts/StudentExcluded.vue';
import CourseTranslation from '../../components/CourseTranslation.vue';
import UserRecord from '../../components/UserRecord.vue';
import ContractAlert from '../../components/ContractAlert.vue';

export default {
  name: 'CourseUnitList',
  components: {
    UnitCard,
    UserRecord,
    ContractAlert,
    CourseTranslation,
  },
  data() {
    return {
      overlay: false,
      isIntersect: false,
      courseUnits: [],
      course: null,
      selectedUnit: null,
    };
  },
  computed: {
    viewContractPreview() {
      const { contract } = this.course;
      return contract && !contract.isMyEnrollment && contract.is_concluded;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    courseId() {
      return this.$route.params.courseId;
    },
    educationStatusComponent() {
      const BY_ATTESTATION_STATUS = {
        [this.$conf.ATTESTATION_STATUSES.enrolled]: StudentEnrolled,
        [this.$conf.ATTESTATION_STATUSES.allowedAttestation]: StudentAllowedAttestation,
        [this.$conf.ATTESTATION_STATUSES.attestated]: StudentAttestated,
        [this.$conf.ATTESTATION_STATUSES.refusedAttestation]: StudentRefusedAttestation,
        [this.$conf.ATTESTATION_STATUSES.excluded]: StudentExcluded,
      };
      return BY_ATTESTATION_STATUS[this.course.prior_record_status] || StudentEnrollWait;
    },
    userRecord() {
      return this.course?.priority_user_prior_record?.user_record;
    },
    contractAlertView() {
      const { contract } = this.course;
      if (this.$user.data.id !== contract?.owner_id && contract && contract?.isPaymentPrePayment) {
        return false;
      }
      return contract && !contract?.isAllPayed;
    },
  },

  async created() {
    this.$loader.start();
    await this.fetchCourse();
    this.$loader.stop();
  },
  methods: {
    routeContract(item) {
      this.$router.push({
        name: 'ContractView',
        params: { id: item.contract.id },
        query: { courseId: item.id },
      });
    },
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.isIntersect = true;
      }
    },
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.courseId, {
        expand: 'prior_record_status,priority_user_prior_record,chat_room,contract',
      }, this.$conf.COURSE_SERVICE.student);
      this.course = item;
      item.checkAttributes();
      item.fetchUnread({ topConsultation: true, userId: this.$user.data.id });
      item.fetchContract(this.$user.data.id);
    },
    viewContract() {
      this.course.contract.view_contract = true;
    },
  },
};
</script>
